var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransition(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8 8",
    style: {
      enableBackground: "new 0 0 8 8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#12DCDC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000067943212877697277660000017289957845938178205_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st0",
    width: 3.4,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    className: "st0",
    width: 3.4,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4.7,
    className: "st0",
    width: 3.4,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 4.7,
    className: "st0",
    width: 3.4,
    height: 3.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransition);
export default __webpack_public_path__ + "static/media/transition.5dcc39b2fb2e218ece9ce936a340b716.svg";
export { ForwardRef as ReactComponent };